import React, { useEffect, useState } from 'react';
import {Avatar, Typography, Grid, Card, Stack, Box, Divider} from '@mui/material';
import { useParams} from 'react-router-dom';
import { firestore } from './FirebaseConfig';

  

const ProfileView = () => {

  const { id } = useParams();
  const [displayName, setDisplayName] = useState('');
  const [avatar, setAvatar] = useState('');
  
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profileRef = firestore.collection('users').doc(id);
        const doc = await profileRef.get();

        if (!doc.exists) {
          console.log('No matching profile document.');
          return;
        }

        const profileData = doc.data();
        setDisplayName(profileData.displayName);
        setAvatar(profileData.photoURL);
        
      } catch (error) {
        console.error('Error fetching profile:', error);
      }

     };

     

    fetchProfile();
  }, [id]);
  return (

    <Stack
      id='profile'
      component='section'
      direction='column'
      minWidth='300px'
      width='90%'
      paddingTop='200px'
      paddingBottom='100px'
      justifyContent='center'
      alignItems='center'
      marginBottom={'20px'}
      marginTop={'200px'}
      sx={{
        py: '100px',
        mx: 6,
        maxWidth: '800px',
        margin: '0px auto',
        
        transition: 'opacity 0.5s ease-in-out',
      }}
    >
    <Card
            style={{
              backgroundColor: 'rgba(0,0,0,0.11',
              height: 'fit-content',
              justifyItems: 'baseline',
              width: '90vw',
              maxWidth: '800px',
              padding: '10px',
              marginBottom: '25px',
              marginTop: '25px',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: '8px',
            }}
          >
            

              <Box sx={{display: 'flex', marginBottom: '20px', flexDirection: 'row', alignContent: 'left', verticalAlign: 'middle', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap'}}>
              <Avatar
              
                src={avatar}
                alt={displayName}
                style={{ marginRight: '10px', width: '100px', height: '100px', alignSelf: 'baseline' }}
              />
             
              <Typography
                variant='h4'
                component='h4'
                sx={{
                  lineHeight: 1,
                  height: 'fit-content',
                  linHeight: 0,
                  color: '#0ea2eb',
                  textAlign: 'center',
                  alignItems: 'center',

                  marginLeft: '0px',
                  verticalAlign: 'middle',
                  '@media (max-width:420px)': {
                    fontSize: '24px',

                    verticalAlign: 'middle',
                    marginLeft: '0px',
                  },
                }}
              >
                {displayName}
              </Typography>
             
           </Box>
            <Divider variant="middle" />
            <Box sx={{marginTop: '20px'}}>
            <Typography
                variant='h5'
                component='h5'
                sx={{
                  lineHeight: 1,
                  height: 'fit-content',
                  linHeight: 0,
                  color: '#121212',
                  textAlign: 'left',
                  alignItems: 'center',

                  marginLeft: '20px',
                  verticalAlign: 'middle',
                  '@media (max-width:420px)': {
                    fontSize: '26px',

                    verticalAlign: 'middle',
                    marginLeft: '0px',
                  },
                }}
              >
                I love remodeling and building, and I love sharing what I have learned over the years.
              </Typography>

            </Box>
            
            
          </Card>

          </Stack>
   
  )}

export default ProfileView;




/*
 <div>
      <h1>Profile Page</h1>
      {displayName && (
        <div>
          <img src={avatar} alt={displayName} style={{ width: '100px', height: '100px', borderRadius: '50%' }} />
          <h2>{displayName}</h2>
          {/* Add any additional profile details here *///}
       //   </div>
//*/

        //  )}
  /*       
        </div>

import React from 'react';
import { useParams } from 'react-router-dom';
import { firestore } from './FirebaseConfig';
import Profile from './Profile';

const ProfilePage = () => {
  const { id } = useParams();
  const [displayName, setDisplayName] = useState('');
  const [avatar, setAvatar] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const profileRef = firestore.collection('users').doc(id);
        const doc = await profileRef.get();

        if (!doc.exists) {
          console.log('No matching profile document.');
          return;
        }

        const profileData = doc.data();
        setDisplayName(profileData.displayName);
        setAvatar(profileData.photoURL);
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    fetchProfile();
  }, [id]);

  return (
    <div>
      <h1>Profile Page</h1>
      {displayName && <Profile displayName={displayName} avatar={avatar} />}
      {/* Add any additional profile-related information or components here *///}
    //</div>
  ///);
//};

//export default ProfilePage;


